<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import i18next from "i18next";

const supportedLanguages = [
	{ code: "de", name: "Deutsch" },
	{ code: "en", name: "English" },
	{ code: "es", name: "Español" },
	{ code: "ar", name: "العربية" },
	{ code: "cs", name: "Čeština" },
	{ code: "el", name: "Ελληνικά" },
	{ code: "fr", name: "Français" },
	{ code: "hi", name: "हिन्दी" },
	{ code: "it", name: "Italiano" },
	{ code: "ja", name: "日本語" },
	{ code: "nl", name: "Nederlands" },
	{ code: "no", name: "Norsk" },
	{ code: "pl", name: "Polski" },
	{ code: "pt", name: "Português" },
	{ code: "ru", name: "Русский" },
	{ code: "zh", name: "中文" },
	// Add more languages here
];

let activeLanguage = i18next.language;

function changeLanguage(event) {
	const newLang = event.target.value;
	localStorage.setItem("language", newLang);
	i18next.changeLanguage(newLang);
	activeLanguage = newLang;
}
</script>

<div class="lang-switcher-dropdown">
  <select bind:value={activeLanguage} on:change={changeLanguage}>
    {#each supportedLanguages as lang (lang.code)}
      <option value={lang.code}>{lang.name}</option>
    {/each}
  </select>
</div>

<style>
  .lang-switcher-dropdown {
    position: fixed;
    top: 95px;
    right: 13px;
    z-index: 101;
  }
  .lang-switcher-dropdown select {
    padding: 8px 12px;
    border-radius: 5px;
    border: 1px solid black;
    background: white;
    font-weight: bold;
    cursor: pointer;
  }
</style>